import SkillzStyle from 'SkillzStyle';
import {StyleSheet} from 'react-native';

const {
  btnTextColorTwo,
  fontSecondary,
  fontBold,
  textColorSecondary,
  fontSizeH5,
  viewPrimaryColor,
  viewSecondaryColor,
  textColorCash,
  fontPrimary,
  fontMedium,
  fontSizeH4,
  fontRegular,
  fontExtraBold,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  balanceSplitContainer: {
    backgroundColor: '#f2f2f2',
    padding: 16,
  },
  boldText: {
    ...fontSizeH5,
    letterSpacing: -0.3,
    fontSize: 15,
    ...textColorSecondary,
    ...fontExtraBold,
  },
  boldTextH4: {
    ...fontBold,
    ...fontSizeH4,
    ...textColorSecondary,
  },
  totalBalanceValue: {
    ...fontBold,
    ...fontSizeH4,
    ...textColorCash,
  },
  normalGreyText: {
    ...fontSizeH5,
    color: '#7A7A7A',
    letterSpacing: -0.3,
    ...fontExtraBold,
  },
  balanceCellContainer: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
  divider: {
    marginHorizontal: 0,
    height: 1,
    marginVertical: 12,
    backgroundColor: '#919eab70',
  },
});
